import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=dd611a6a&scoped=true&"
import script from "./destination.vue?vue&type=script&lang=js&"
export * from "./destination.vue?vue&type=script&lang=js&"
import style0 from "./destination.vue?vue&type=style&index=0&id=dd611a6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd611a6a",
  null
  
)

export default component.exports